import { ModelBase } from './model-base';

export class AllergenValues extends ModelBase {

  constructor(s?: any) {
    super(s);
  }

  celery: number;
  crustaceans: number;
  eggs: number;
  fish: number;
  gluten: number;
  lupin: number;
  milk: number;
  molluscs: number;
  mustard: number;
  nuts: number;
  peanuts: number;
  sesameSeeds: number;
  soybeans: number;
  sulphurDioxide: number;

  almonds: number;
  brazils: number;
  cashews: number;
  hazelnuts: number;
  macadamias: number;
  pecans: number;
  pistachios: number;
  walnuts: number;

  barley: number;
  oats: number;
  rye: number;
  wheat: number;

  minorAllergens: string[] = ['wheat', 'rye', 'barley', 'oats', 'almonds', 'hazelnuts', 'walnuts', 'cashews', 'pecans', 'brazils', 'pistachios', 'macadamias'];

  nutsAllergens: string[] = ['almonds', 'brazils', 'cashews', 'hazelnuts', 'macadamias', 'pecans', 'pistachios', 'walnuts'];

  glutenAllergens: string[] = ['barley', 'oats', 'rye', 'wheat'];

  isMajor(allergenName: string): boolean {
    //this should use nutrition service
    return !this.minorAllergens.includes(allergenName);
  };
}

export class Allergen {

  isComposite: boolean;

  // name: the name of the allergen in lowerCamelCase format e.g. 'sesameSeeds'
  // displayName: the name of the allergen to be displayed in the ui e.g. 'Sesame Seeds'
  // index: the index of the allergen to be used when sorting by major/minor then alphabetically
  // major: indicates that this is a major allergen. Major allergen data is provided by suppliers, minor allergens are not
  constructor(public name: string, public displayName: string, public shortCode: string, public index: number, public major: boolean, public parent?: string) {
    this.isComposite = false;
    if (name === 'gluten') this.isComposite = true;
    if (name === 'nuts') this.isComposite = true;

  }

  // the containsName functions returns the name of the database property that indicates whether a menu item or ingredient contains an allergen. e.g. 'containsSesameSeeds'
  containsName(): string {
    if (!this.name || this.name.length === 0)
      return this.name;
    const c = this.name.charAt(0);
    return 'contains' + c.toUpperCase() + this.name.slice(1);
  }
}
